export const todoColumnTransformer = (data = []) => {
  const transformedData = data.map(item => {
    return {
      id: item?.id,
      key: item?.id,
      title: item?.columnName,
      isUserSelectedDefault: item?.isUserSelectedDefault,
    }
  })
  const userSelection = transformedData?.filter(item => item?.isUserSelectedDefault)?.map(item => item?.id)
  return { data: transformedData, userSelection }
}
